module.exports = __webpack_public_path__ + "static/media/extra_oral_right_small.25d2bbc3.png";